import type { AspectRatioOption } from "#lib/components/images/types.js";

export const LANDING_PAGE_CROPPER_ASPECT_RATIO = 9 / 16;
export const LANDING_PAGE_CROPPER_CAPTION = "9:16 is the standard ratio for images on the landing page. Display may vary due to responsiveness.";
export const LOGO_CROPPER_CAPTION = "Square or horizontal images recommended";
export const AGENT_IMAGE_ASPECT_RATIO = 1;
export const CONTACT_IMAGE_ASPECT_RATIO = 1;
export const WORKSPACE_IMAGE_ASPECT_RATIO = 1;
export const ORG_IMAGE_ASPECT_RATIO = 1;
export const TEAM_IMAGE_ASPECT_RATIO = 1;
export const PROFILE_IMAGE_ASPECT_RATIO = 1;
export const MODULE_ICON_ASPECT_RATIO = 1;
export const MODULE_IMAGE_ASPECT_RATIO = 403 / 156;
export const DEFAULT_IMAGE_ASPECT_RATIO = 1;
export const LANDSCAPE_IMAGE_ASPECT_RATIO = 16 / 9;
const PORTRAIT_IMAGE_ASPECT_RATIO = 4 / 5;

export const UPLOADABLE_IMAGE_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml", "image/gif", "image/webp"];
export const UPLOADABLE_CODE_RGB_LOGO_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml", "image/gif", "application/pdf"];
export const UPLOADABLE_CODE_CMYK_LOGO_TYPES = ["image/jpeg", "image/jpg", "application/pdf", "application/postscript"];
export const UPLOADABLE_FILE_DESTINATION_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml", "image/gif", "application/pdf", "video/mp4", "video/quicktime", "text/vcard"];
export const UPLOADABLE_DOCUMENT_TYPES = ["application/pdf"];
export const UPLOADABLE_MOVIE_TYPES = ["video/mp4", "video/quicktime"];

export const MAX_UPLOAD_PDF_EPS_SIZE = 5 * 1024 * 1024; // 5MB
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024; //10MB
export const MAX_PDF_SIZE = 50 * 1024 * 1024; //50MB
export const MAX_MOVIE_SIZE = 500 * 1024 * 1024; //500MB
export const MAX_VCARD_SIZE = 1 * 1024 * 1024; // 1MB

export const ASPECT_RATIOS: AspectRatioOption[] = [{ name: "Freeform" }, { name: "Landscape(16:9)", ratio: LANDSCAPE_IMAGE_ASPECT_RATIO }, { name: "Square (1:1)", ratio: 1 }, { name: "Portrait(4:5)", ratio: PORTRAIT_IMAGE_ASPECT_RATIO }];
export const PRESET_ASPECT_RATIO_MATCH_TOLERANCE = 0.01;
